import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography, Button, Hidden, Grid,
} from '@material-ui/core';
import NotificationBar from '@trdk/style/NotificationBar';
import { connect } from 'react-redux';
import * as yup from 'yup';
import DefaultForm from '../../../components/default-form';
import { doFetch, fetchClear } from '../../../services/fetch/fetch.actions';
import Dialog from '../../../components/dialog';
import UserForm from '../../../components/user-form';
import RoleSelection from '../../../components/role-selection';
import {
  fetchUser, postActivateUser, postEditUser, postRemoveUser,
} from '../../../services/admin/user-service';
import { fetchClear as fetchClearUsers } from './users.actions';
import { fetchRole } from '../../../services/politician/profile-service';
import getValues from './functions/getValues';
import { mapUserData } from './functions/get-send-format';
import * as userConstants from './functions/constants';

const schema = yup.object().shape({
  fnr: yup.string().matches(/^[0-9]{11}$/, 'Fødselsnummer må være 11 siffer'),
  epost: yup.string().email(),
  fornavn: yup.string(),
  etternavn: yup.string(),
  adresse: yup.string(),
  parti: yup.string().required('Feltet er påkrevd'),
  gender: yup.string(),
  postnr: yup.number().typeError('Kan ikke inneholde tekst'),
  poststed: yup.string(),
  tlfprivat: yup.string().matches(/^[0-9]{1,8}$/, 'Telefonnummer ikke gyldig'),
  arbeidssted: yup.string(),
  bankkontonummer: yup.number(),
  generalInfo: yup.string(),
  // stilling: yup.string(),
});

const roles = [
  'politician',
  'admin',
  'superadmin',
  'secretary',
  'observer',
  'other',
];

class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      dialogActivateOpen: false,
      values: {},
      chosenRoles: ['politician'],
      alreadySet: false,
    };
  }

  componentDidMount = () => {
    const {
      match: { params: { id } }, dispatch, history,
      me: { fetching, fetched },
    } = this.props;
    dispatch(doFetch('GET_USER', fetchUser(id)
      .then((res) => {
        if (!res.ok) {
          history.push('/admin');
          throw res.statusText;
        }
        return res.json();
      })));
    if (!fetching && !fetched) {
      dispatch(doFetch('ME', fetchRole()
        .then((res) => {
          if (!res.ok) {
            throw res.statusText;
          }
          return res.json();
        })));
    }
    dispatch(fetchClear('EDIT_POLITICIAN'));
  }

  componentDidUpdate() {
    const { currentUser: { fetched, payload } } = this.props;
    const { alreadySet } = this.state;
    // eslint-disable-next-line react/no-did-update-set-state, max-len
    if (!alreadySet && fetched) { this.setState({ chosenRoles: payload.Resources.roles || [], alreadySet: true }); }
  }

  deactivateUser = (activate) => {
    const { match: { params: { id: guid } }, dispatch, history } = this.props;
    dispatch(doFetch('EDIT_USER', postActivateUser(guid, activate)
      .then((res) => {
        if (!res.ok) {
          throw res.statusText;
        }
        return res;
      }).then((r) => {
        dispatch(fetchClearUsers());
        dispatch(fetchClear('ADD_PARTY'));
        dispatch(fetchClear('PARTIES'));
        dispatch(fetchClear('COMMITTEES'));
        history.push('/admin');
        return r;
      }),
    { status: activate }));
  }

  deletePendingUser = (id) => {
    const { dispatch, history } = this.props;
    postRemoveUser(id)
      .then((res) => {
        if (!res.ok) { throw res.statusText; }
        dispatch(fetchClearUsers());
        history.push('/admin');
        return res;
      });
  }

  handleSubmit = (values, enabled) => {
    const {
      match: { params: { id } },
      history,
      dispatch,
      currentUser: {
        payload: { Resources: currentUser },
      },
    } = this.props;
    const { chosenRoles } = this.state;
    const oldValues = getValues(currentUser);
    const newValues = Object.keys(oldValues)
      .filter(key => values[key] != null && oldValues[key] !== values[key])
      .reduce((acc, curr) => ({ ...acc, [curr]: values[curr] }), {});

    let rolesRemove = [];
    let rolesAdd = [];
    if (JSON.stringify(currentUser.roles || []) !== JSON.stringify(chosenRoles)) {
      rolesRemove = currentUser.roles ? currentUser.roles.filter(x => !chosenRoles.includes(x)) : [];
      rolesAdd = chosenRoles ? chosenRoles.filter(x => (currentUser.roles ? !currentUser.roles.includes(x) : chosenRoles)) : [];
    }

    if (Object.keys(newValues).length > 0 || enabled || rolesRemove.length > 0 || rolesAdd.length > 0) {
      const formattedValues = new Map();

      mapUserData(formattedValues, newValues);
      if (enabled) {
        formattedValues.set('active', 1);
      }
      if (rolesRemove.length > 0 || rolesAdd.length > 0) {
        formattedValues.set('roles', chosenRoles);
      }

      const editObject = Object.fromEntries(formattedValues);

      dispatch(doFetch(
        'EDIT_USER',
        postEditUser(id, editObject).then((res) => {
          if (!res.ok) {
            throw res.statusText;
          }
          dispatch(fetchClearUsers());
          dispatch(fetchClear('ADD_PARTY'));
          dispatch(fetchClear('PARTIES'));
          history.push('/admin');
          return res;
        }),
      ));
    } else {
      history.push('/admin');
    }
  }

  saveActivateUser = (values) => {
    this.setState({ values, dialogActivateOpen: true });
  }

  render() {
    const {
      classes,
      currentUser: {
        fetched,
        fetching,
        error: fetchError,
        payload: { Resources: currentUser },
      },
      editUser: { error: editError },
      me: { fetched: meFetched, payload: me },
    } = this.props;

    const {
      dialogOpen, dialogActivateOpen, values, chosenRoles,
    } = this.state;

    return (
      <div className={classes.container}>
        <Grid container spacing={2} direction="row" justify="space-between">
          {((currentUser && currentUser.active !== userConstants.DISABLED) || (me.roles && me.roles.includes('superadmin'))) && (
            <Hidden smUp>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" className={classes.deactivateText} onClick={() => this.setState({ dialogOpen: true })}>
                  {currentUser && currentUser.active !== userConstants.ENABLED ? 'Slett bruker?' : 'Deaktiver bruker?'}
                </Typography>
              </Grid>
            </Hidden>
          )}
          <Grid item xs={12} sm={6}>
            <Typography variant="h4" color="primary">
              {currentUser && currentUser.active === userConstants.PENDING ? 'Behandle søknad' : 'Rediger bruker'}
            </Typography>
          </Grid>
          {((currentUser && currentUser.active !== userConstants.DISABLED) || (me.roles && me.roles.includes('superadmin'))) && (
            <Hidden xsDown>
              <Grid item xs={12} sm={6} className={classes.buttongrid}>
                <Button variant="contained" disabled={fetchError || fetching} className={classes.button} onClick={() => this.setState({ dialogOpen: true })}>
                  {currentUser && currentUser.active !== userConstants.ENABLED ? 'Slett bruker' : 'Deaktiver bruker'}
                </Button>
              </Grid>
            </Hidden>
          )}
          {meFetched && (
            <RoleSelection
              roles={me.roles.includes('superadmin') ? roles : ['politician', 'secretary', 'observer', 'other']}
              chosenRoles={chosenRoles}
              onChange={v => (
                this.setState({
                // eslint-disable-next-line no-nested-ternary
                  chosenRoles: v.target.value.length === 0 ? chosenRoles : (
                    // eslint-disable-next-line no-nested-ternary
                    (v.target.value.length === 1 && v.target.value.indexOf('other')) === 0 ? ['other']
                      : v.target.value.indexOf('other') > 0
                        ? ['other'] : v.target.value.filter(e => e !== 'other')
                  ),
                })
              )}
            />
          )}
        </Grid>
        {!fetchError && fetched && [
          <Dialog
            key={1}
            title={currentUser.active === userConstants.PENDING ? 'Slett søknad' : 'Deaktiver bruker'}
            text={`Ønsker du å ${currentUser.active !== userConstants.ENABLED ? 'slette' : 'deaktivere'} ${currentUser.givenName} ${currentUser.familyName}${currentUser.active === userConstants.PENDING ? ' sin søknad' : ''}?
            ${currentUser.active === userConstants.ENABLED ? 'Brukeren vil da fjernes som medlem fra partiet og utvalgene en er medlem i.' : ''}`}
            open={dialogOpen}
            handleClose={() => this.setState({ dialogOpen: false })}
            handleAccept={currentUser.active !== userConstants.ENABLED
              ? () => this.deletePendingUser(currentUser.id)
              : () => this.deactivateUser(0)}
            agreeButton={currentUser.active !== userConstants.ENABLED ? 'Slett' : 'Deaktiver'}
          />,
          <Dialog
            key="activatePendingPolitician"
            title="Aktiver bruker"
            text={`Ønsker du å aktivere ${currentUser.givenName} ${currentUser.familyName}?`}
            open={dialogActivateOpen}
            handleClose={() => this.setState({ dialogActivateOpen: false })}
            handleAccept={() => this.handleSubmit(values, true)}
            agreeButton="Aktiver"
            noTimer
          />,
          currentUser !== {} && currentUser.active === userConstants.ENABLED && chosenRoles.indexOf('politician') > -1 && [
            <DefaultForm
              isLoading={fetching}
              key={2}
              initialValues={getValues(currentUser)}
              onSubmit={v => this.handleSubmit(v, false)}
              schema={schema}
              isAdmin
              editing
            />,
          ],
          currentUser !== {} && currentUser.active !== userConstants.ENABLED && chosenRoles.indexOf('politician') > -1 && (
            <DefaultForm
              isLoading={fetching}
              key={2}
              initialValues={getValues(currentUser)}
              onSubmit={this.saveActivateUser}
              schema={schema}
              pending
              isAdmin
              editing
            />
          ),
          chosenRoles.indexOf('politician') < 0 && (
            <UserForm
              key="lastet"
              initialValues={{
                fornavn: currentUser.givenName,
                etternavn: currentUser.familyName,
                fnr: '',
                active: 1,
                epost: currentUser.email || '',
                tlfprivat: currentUser.phone || '',
              }}
              handleSubmit={currentUser.active === userConstants.ENABLED ? v => this.handleSubmit(v, false) : this.saveActivateUser}
              editing
              deactive={currentUser.active !== userConstants.ENABLED}
            />
          ),
        ]}
        {fetching && (
          <DefaultForm
            isLoading={fetching}
            key={2}
            initialValues={{}}
            onSubmit={this.handleSubmit}
            schema={{}}
            editing
          />
        )}
        {editError && <NotificationBar message={`Feil ved lagring: "${editError}"`} variant="error" />}
      </div>
    );
  }
}

const styles = theme => ({
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'bottom',
    marginBottom: '1rem',
    maxWidth: '60rem',
  },
  container: {
    maxWidth: '60rem',
    marginBottom: '4rem',
  },
  buttongrid: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    '&:hover': {
      backgroundColor: '#f00',
      color: '#fff',
    },
    marginRight: '1rem',
  },
  deactivateText: {
    color: theme.palette.error.main,
    textDecoration: 'underline',
  },
  formControl: {
    width: '100%',
  },
});

EditUser.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.any.isRequired,
  match: PropTypes.any.isRequired,
  dispatch: PropTypes.any.isRequired,
  currentUser: PropTypes.any.isRequired,
  editUser: PropTypes.any.isRequired,
  me: PropTypes.object.isRequired,
};

const mapStateToProps = ({
  currentUser, editUser, me,
}) => ({
  currentUser,
  editUser,
  me,
});

export default connect(mapStateToProps)(withStyles(styles)(EditUser));
